import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { createPaymentIntent } from "../api/stripeApi";
import { StripeCheckout } from "../components/Stripe/StripeCheckout";
import api from "../api/api";

export default function PaymentPage() {
    const { shipmentId } = useParams();

    const [clientSecret, setClientSecret] = useState("");
    const [orderId, setOrderId] = useState(null);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!shipmentId) {
            setError("Shipment ID is missing.");
            setLoading(false);
            return;
        }

        const init = async () => {
            try {
                const shipmentRes = await api.get(`/Shipment/${shipmentId}`);
                setOrderId(shipmentRes.data.orderId);

                const paymentRes = await createPaymentIntent({
                    shipmentId: Number(shipmentId),
                });

                setClientSecret(paymentRes.clientSecret);
                setOrderId(paymentRes.orderId);
            } catch (err) {
                setError(
                    err?.response?.data?.message ||
                    err.message ||
                    "Payment failed"
                );
            } finally {
                setLoading(false);
            }
        };

        init();
    }, [shipmentId]);

    if (loading) return <p>Preparing payment...</p>;

    if (error)
        return <p className="text-red-600 text-center mt-6">{error}</p>;

    return (
        <div className="max-w-xl mx-auto p-6 bg-white rounded shadow">
            <h2 className="text-xl font-bold mb-4">Payment</h2>

            {clientSecret && (
                <StripeCheckout
                    clientSecret={clientSecret}
                    orderId={orderId}
                    shipmentId={shipmentId}
                />
            )}
        </div>
    );
}